var ObjectValueModel = function (pageModelHndl, parentAttribute) {
    var that = this;

    //baseData
    that.LocalizationKey = ko.observable();
    that.DisplayText = ko.observable();
    that.ObjectValueId = ko.observable();
    that.AttributeSpecificId = ko.observable();

    that.SortId = ko.observable();
    that.CustomValueProperties = [];

    //flags
    that.IsEnabled = ko.observable(true);
    that.HasError = ko.observable(false);

    //handle
    that.ParentAttribute = ko.observable(parentAttribute);

    //functions
    that.PopulateObjectValueModel = function (objectValueData) {
        that.LocalizationKey(objectValueData.LocalizationKey);
        that.DisplayText(GetTranslateableResource(objectValueData.DisplayText));
        that.ObjectValueId(objectValueData.ObjectValueId);
        that.AttributeSpecificId(objectValueData.AttributeSpecificId);

        that.SortId(objectValueData.SortId);
        that.CustomValueProperties = objectValueData.CustomValueProperties;

        if (that.CustomValueProperties && that.CustomValueProperties.length > 0 ) {
            console.info("CustomValues found", that, that.CustomValueProperties);
        }
    };

    that.SetSelectedValue = function (value, e) {
        pageModelHndl.pProductModel.SelectedValue = value;
        return true;
    };
    that.SetSelectedValueGallerie = function (value, e) {
        pageModelHndl.pProductModel.SelectedValue = value;
        pageModelHndl.pProductModel.SelectedAttribute = value.ParentAttribute();
        pageModelHndl.pProductModel.SelectedAttribute.SelectedObjectValueId(value.ObjectValueId());

        // Gallerie autocheck checkbox
        $(e.currentTarget).parent('.ad-thumb-item').find('input').attr('checked', 'checked');
    };
};